import { concat, isEmpty, get } from 'lodash';
import todoListType from './TodoList.type';
import { Page_Size } from '../../../../../Components/helper';

const initialState = {
  todoDataList: [],
  mainSamples: [],
  sampleTodoList: [],
  currentRequestId: null,
  filterValues: {
    selectedSeason: [],
    selectedYear: [],
    selectedBrand: [],
    selectedSupplier: [],
    selectedSampleType: [],
    selectedColour: [],
    selectedColourGroup: [],
    selectedSubBrand: [],
    selectedProductType: [],
    selectedTrackingStatus: [],
    selectedSampleStatus: [],
    category1: [],
    category2: [],
    category3: [],
    category4: [],
    selectedLicensor: [],
    selectedLicense: [],
    selectedLikeness: [],
    searchText: '',
    pageIndex: 1,
    pageSize: Page_Size,
    sortOrder: '',
    sortPropertyName: '',
    loading: false,
  },
  sampleTodoListTotalCount: 0,
  sampleTodoListCount: 0,
  todoListTabs: [
    {
      tabsId: 19,
      tabName: 'Inbox',
      count: 0,
      colour: '#6C757D',
      url: 'my-todo',
      hide: false,
      type: 'my-todo',
      iconName: 'icon-Inbox-In',
    },
    {
      tabsId: 1,
      tabName: 'Product Progress',
      count: 0,
      colour: '#FBB555',
      url: 'sample-requests',
      hide: true,
    },
    {
      tabsId: 2,
      tabName: 'Bill of Material Due Dates',
      count: 0,
      colour: '#F55258',
      url: 'bill-of-material',
      hide: true,
    },
    {
      tabsId: 3,
      tabName: 'Costing Request',
      count: 0,
      colour: '#F55258',
      url: 'costing-request',
      hide: true,
    },
    {
      tabsId: 4,
      tabName: 'Document Expiration Dates',
      count: 0,
      colour: '#1E9D78',
      url: 'document-expiration-dates',
      hide: true,
    },
    {
      tabsId: 5,
      tabName: 'Forums',
      count: 0,
      colour: '#1E9D78',
      url: 'forums',
      hide: true,
    },
    {
      tabsId: 6,
      tabName: 'Handover/Shipment Dates',
      count: 0,
      colour: '#1E9D78',
      url: 'handover-shipment-dates',
      hide: true,
    },
    {
      tabsId: 7,
      tabName: 'Negotiations',
      count: 0,
      colour: '#FBB555',
      url: 'negotiations',
      hide: true,
    },
    {
      tabsId: 8,
      tabName: 'PO Confirmations',
      count: 0,
      colour: '#FBB555',
      url: 'po-confirmations',
      hide: true,
    },
    {
      tabsId: 9,
      tabName: 'PO Supporting  Documents',
      count: 0,
      colour: '#FBB555',
      url: 'po-supporting-documents',
      hide: true,
    },
    {
      tabsId: 10,
      tabName: 'Product Approve by Dates',
      count: 0,
      colour: '#1E9D78',
      url: 'product-approve-dates',
      hide: true,
    },
    {
      tabsId: 15,
      tabName: 'PROGRESS_BAR.PROGRESS_INDECATOR',
      count: 0,
      colour: '#FBB555',
      url: 'progress-indicator',
      hide: false,
      type: 'progress-indicator',
      iconName: 'icon-Product-Progress',
    },
    {
      tabsId: 11,
      tabName: 'PROGRESS_BAR.SAMPLE_REQUEST',
      count: 0,
      colour: '#FBB555',
      url: 'sample-requests',
      hide: false,
      type: 'samples',
      iconName: 'icon-Inside-Samples-Icon',
    },
    {
      tabsId: 19,
      tabName: 'Supporting Documents',
      count: 0,
      colour: '#FBB555',
      url: 'supporting-documents',
      hide: false,
      type: 'supporting-documents',
      iconName: 'icon-Supporting-Docs',
    },
    {
      tabsId: 12,
      tabName: 'Supplier To Do',
      count: 0,
      colour: '#FBB555',
      url: 'supplier-todo',
      hide: false,
      type: 'supplier-todo',
      iconName: 'icon-Supplier-To-Do',
    },
    {
      tabsId: 13,
      tabName: 'PROGRESS_BAR.SUPPLIER_SUGGESTION',
      count: 0,
      colour: '#FBB555',
      url: 'suggestion',
      hide: false,
      type: 'suggestion',
      iconName: 'icon-Supplier-Suggest',
    },
    {
      tabsId: 14,
      tabName: 'PROGRESS_BAR.COSTINGS',
      count: 0,
      colour: '#FBB555',
      url: 'costing',
      hide: false,
      type: 'costing',
      iconName: 'icon-Product-Costing',
    },
    {
      tabsId: 15,
      tabName: 'PROGRESS_BAR.PURCHASE_ORDERS',
      count: 0,
      colour: '#FBB555',
      url: 'purchase-order',
      hide: true,
      type: 'purchase-order',
      iconName: 'icon-PO-Preview',
    },

    {
      tabsId: 16,
      tabName: 'PROGRESS_BAR.SUBMIT_DOWNLOAD',
      count: 0,
      colour: '#FBB555',
      url: 'submit-download',
      hide: false,
      type: 'submit-download',
      iconName: 'icon-Submit-and-Download',
    },
    {
      tabsId: 17,
      tabName: 'PROGRESS_BAR.TESTING',
      count: 0,
      colour: '#FBB555',
      url: 'testing',
      hide: false,
      type: 'testing',
      iconName: 'icon-Inside-Testing',
    },
    {
      tabsId: 18,
      tabName: 'PROGRESS_BAR.PURCHASE_ORDERS',
      count: 0,
      colour: '#1E9D78',
      url: 'product-purchase-order-todo',
      hide: false,
      type: 'product-purchase-order-todo',
      iconName: 'icon-PO-Preview',
    },
  ],
  sampleSelectedIds: [],
  mstOtherSamples: [],
};

const TodoList = (state = initialState, action) => {
  switch (action.type) {
    case todoListType.GET_TODO_LIST:
      return {
        ...state,
        todoDataList: action.payload,
      };
    case todoListType.GET_MAIN_SAMPLES:
      return {
        ...state,
        mainSamples: action.payload,
      };
    case todoListType.SET_SAMPLE_REQUESTS_TODOLIST: {
      if (
        action.payload.requestId &&
        state.currentRequestId &&
        Number(action.payload.requestId) < Number(state.currentRequestId)
      ) {
        return state;
      }
      const updatedArry = setArrayByCase(state.sampleTodoList, action.payload);
      return {
        ...state,
        sampleTodoList: updatedArry,
        sampleTodoListTotalCount: action.payload.totalCount,
        currentRequestId: action.payload.requestId || state.currentRequestId,
      };
    }
    case todoListType.SET_FILTER_SORT_DATA:
      return {
        ...state,
        filterValues: { ...state.filterValues, ...action.payload },
      };
    case todoListType.SET_TODO_LIST_COUNT: {
      const cloneArray = state.todoListTabs;
      const foundIndex = cloneArray.findIndex((val) => val.type === action.payload.type);
      cloneArray[foundIndex].count = action.payload.totalCount;
      cloneArray[foundIndex].colour = action.payload.colour;

      return {
        ...state,
        todoListTabs: cloneArray,
      };
    }
    case todoListType.SET_SELECTED_IDS_ARRAY:
      return {
        ...state,
        sampleSelectedIds: action.payload,
      };
    case todoListType.GET_OTHER_SAMPLES_TODO_LIST:
      return {
        ...state,
        mstOtherSamples: action.payload,
      };
    default:
      return state;
  }
};

const setArrayByCase = (array, payload) => {
  if (!isEmpty(get(payload, 'searchText')) && get(payload, 'isScrolled')) {
    array = [...array, ...payload.data];
    return array;
  }
  if (!isEmpty(get(payload, 'searchText'))) {
    array = payload.data;
    return array;
  }
  if (get(payload, 'isScrolled')) {
    array = concat(array, payload.data);
    return array;
  }
  return payload.data;
};
export default TodoList;
